import React, { useEffect, useState, useMemo } from "react"
import PropTypes from "prop-types"
import Image from "next/image"
import { useDeviceType } from "@/hooks/useDeviceType"

const ToolCard = props => {
  const {
    alt = "",
    src = "",
    description = "",
    name = "",
    showReverse = false,
    ctaType = "",
    buttonLink = "",
    buttonLabel = "",
  } = props
  const Buttonprops = {
    children: "Button",
    variant: "primary",
    size: "small",
    fullWidth: false,
    disabled: false,
  }
  const { isBelow, isAbove } = useDeviceType(480)

  const reverseClass = showReverse && isAbove ? "flex-row-reverse" : ""
  const toolBoxClass = isBelow ? "flex-col" : `${reverseClass} flex-row`
  const ImagBeoxClass = isBelow ? "w-full" : "w-[400px]"
  const buttonClick = () => {
    window.open(buttonLink, "_blank")
  }
  return (
    <div className={`row koh-top-row flex flex-row w-full `}>
      <div className="card-section flex  flex-col gap-0 md:gap-6 w-full">
        <hr className="border-gray-300 flex-grow line" />

        <div className={`${toolBoxClass} flex w-full gap-4`}>
          <div
            className={`image-wrapper relative flex flex-col gap-5 max-md:w-full`}
          >
            <Image
              src={src}
              alt={alt}
              width={300}
              height={232}
              className={`object-cover image-section ${ImagBeoxClass}`}
            />
          </div>
          <div className="article-button-section flex flex-col gap-4 w-full">
            {name && (
              <p className="articleHeading mb-1 text-lg md:text-2xl leading-none font-normal lg:font-semibold text-[#232323]">
                {name}
              </p>
            )}
            {description ? (
              <div className="koh-pro-toolbox-text-body">
                <p className="font-normal break-words">{description}</p>
              </div>
            ) : null}
            <div className=" flex w-full">
              <button
                onClick={buttonClick}
                class="px-4 py-2 text-md md:text-lg bg-black w-[140px] button text-white font-semibold text-base rounded hover:bg-gray-400 hover:text-white transition"
              >
                {buttonLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ToolCard
